import * as FiIcons from 'react-icons/fi';

// Central icon registry. Engineer screens reference the full fixture set
// (Wrench, Package, Navigation, …) — every key maps to a real Fi icon so
// SafeIcon never renders its AlertTriangle fallback.
export const Icons = {
  Activity: FiIcons.FiActivity,
  AlertCircle: FiIcons.FiAlertCircle,
  AlertTriangle: FiIcons.FiAlertTriangle,
  Archive: FiIcons.FiArchive,
  ArrowLeft: FiIcons.FiArrowLeft,
  ArrowRight: FiIcons.FiArrowRight,
  Bell: FiIcons.FiBell,
  Book: FiIcons.FiBook,
  Calendar: FiIcons.FiCalendar,
  Camera: FiIcons.FiCamera,
  Cash: FiIcons.FiDollarSign,
  Check: FiIcons.FiCheck,
  CheckCircle: FiIcons.FiCheckCircle,
  ChevronDown: FiIcons.FiChevronDown,
  ChevronLeft: FiIcons.FiChevronLeft,
  ChevronRight: FiIcons.FiChevronRight,
  Clipboard: FiIcons.FiClipboard,
  Clock: FiIcons.FiClock,
  Cloud: FiIcons.FiCloud,
  Compass: FiIcons.FiCompass,
  CreditCard: FiIcons.FiCreditCard,
  Download: FiIcons.FiDownload,
  Droplet: FiIcons.FiDroplet,
  Edit: FiIcons.FiEdit,
  FileSearch: FiIcons.FiFileText,
  FileText: FiIcons.FiFileText,
  Home: FiIcons.FiHome,
  Image: FiIcons.FiImage,
  Inbox: FiIcons.FiInbox,
  Info: FiIcons.FiInfo,
  Layers: FiIcons.FiLayers,
  Link: FiIcons.FiLink,
  List: FiIcons.FiList,
  Lock: FiIcons.FiLock,
  LogIn: FiIcons.FiLogIn,
  LogOut: FiIcons.FiLogOut,
  Map: FiIcons.FiMap,
  MapPin: FiIcons.FiMapPin,
  Menu: FiIcons.FiMenu,
  MessageCircle: FiIcons.FiMessageCircle,
  Mic: FiIcons.FiMic,
  MoreHorizontal: FiIcons.FiMoreHorizontal,
  Navigation: FiIcons.FiNavigation,
  Package: FiIcons.FiPackage,
  Pen: FiIcons.FiPenTool,
  Pipe: FiIcons.FiGitMerge,
  Plus: FiIcons.FiPlus,
  RefreshCw: FiIcons.FiRefreshCw,
  Search: FiIcons.FiSearch,
  Send: FiIcons.FiSend,
  Settings: FiIcons.FiSettings,
  Shield: FiIcons.FiShield,
  Sliders: FiIcons.FiSliders,
  Sparkle: FiIcons.FiCpu,
  Tool: FiIcons.FiTool,
  Upload: FiIcons.FiUpload,
  User: FiIcons.FiUser,
  Users: FiIcons.FiUsers,
  Wrench: FiIcons.FiTool,
  X: FiIcons.FiX,
  Zap: FiIcons.FiZap
};
